// removed by extract-text-webpack-plugin
module.exports = {"root":"FormContainer__root___3ncgB","logo":"FormContainer__logo___TLC4u","fakeItem":"FormContainer__fakeItem___2NXsL","container":"FormContainer__container___7Hiou","formCard":"FormContainer__formCard___3U9hr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NonLoggedLayout/FormContainer/FormContainer.scss
// module id = 2223
// module chunks = 0